
const faixasDeFrete = [
{ regiao: "ACRE - CAPITAL", cepInicial: 69900000, cepFinal: 69920999, valor: 29.9, prazo: 17 },
{ regiao: "ACRE - INTERIOR", cepInicial: 69921000, cepFinal: 69999999, valor: 29.9, prazo: 17 },
{ regiao: "ALAGOAS - CAPITAL", cepInicial: 57000000, cepFinal: 57099999, valor: 29.9, prazo: 17 },
{ regiao: "ALAGOAS - INTERIOR", cepInicial: 57100000, cepFinal: 57999999, valor: 29.9, prazo: 17 },
{ regiao: "AMAPÁ - CAPITAL", cepInicial: 68900000, cepFinal: 68914999, valor: 29.9, prazo: 17 },
{ regiao: "AMAPÁ - INTERIOR", cepInicial: 68915000, cepFinal: 68999999, valor: 29.9, prazo: 17 },
{ regiao: "AMAZONAS - CAPITAL", cepInicial: 69000000, cepFinal: 69099999, valor: 29.9, prazo: 17 },
{ regiao: "AMAZONAS - DEMAIS", cepInicial: 69400000, cepFinal: 69899999, valor: 29.9, prazo: 17 },
{ regiao: "AMAZONAS - INTERIOR", cepInicial: 69100000, cepFinal: 69299999, valor: 29.9, prazo: 17 },
{ regiao: "BAHIA - CAPITAL", cepInicial: 40000000, cepFinal: 44470999, valor: 19.9, prazo: 15 },
{ regiao: "BAHIA - INTERIOR", cepInicial: 44471000, cepFinal: 48999999, valor: 29.9, prazo: 15 },
{ regiao: "CEARÁ - CAPITAL", cepInicial: 60000000, cepFinal: 61900999, valor: 19.9, prazo: 15 },
{ regiao: "CEARÁ - INTERIOR", cepInicial: 61901000, cepFinal: 63999999, valor: 29.9, prazo: 15 },
{ regiao: "DISTRITO FEDERAL - CAPITAL", cepInicial: 70000000, cepFinal: 70999999, valor: 19.9, prazo: 9 },
{ regiao: "DISTRITO FEDERAL - CIDADES SATÉLITES", cepInicial: 71000000, cepFinal: 72799999, valor: 24.9, prazo: 12 },
{ regiao: "DISTRITO FEDERAL - INTERIOR", cepInicial: 73000000, cepFinal: 73699999, valor: 24.9, prazo: 12 },
{ regiao: "ESPIRITO SANTO - CAPITAL", cepInicial: 29000000, cepFinal: 29099999, valor: 14.9, prazo: 9 },
{ regiao: "ESPIRITO SANTO - INTERIOR", cepInicial: 29100000, cepFinal: 29999999, valor: 19.9, prazo: 12 },
{ regiao: "GOIÁS - CAPITAL", cepInicial: 74000000, cepFinal: 74899999, valor: 19.9, prazo: 12 },
{ regiao: "GOIÁS - INTERIOR1", cepInicial: 72800000, cepFinal: 72999999, valor: 24.9, prazo: 12 },
{ regiao: "GOIÁS - INTERIOR2", cepInicial: 73700000, cepFinal: 74000999, valor: 24.9, prazo: 12 },
{ regiao: "GOIÁS - INTERIOR3", cepInicial: 74900000, cepFinal: 76799999, valor: 24.9, prazo: 12 },
{ regiao: "MARANHÃO - CAPITAL", cepInicial: 65000000, cepFinal: 65109999, valor: 24.9, prazo: 17 },
{ regiao: "MARANHÃO - INTERIOR", cepInicial: 65110000, cepFinal: 65999999, valor: 29.9, prazo: 17 },
{ regiao: "MATO GROSSO - CAPITAL", cepInicial: 78000000, cepFinal: 78109999, valor: 19.9, prazo: 17 },
{ regiao: "MATO GROSSO - INTERIOR", cepInicial: 78110000, cepFinal: 78899999, valor: 24.9, prazo: 19 },
{ regiao: "MATO GROSSO DO SUL - CAPITAL", cepInicial: 79000000, cepFinal: 79124999, valor: 19.9, prazo: 17 },
{ regiao: "MATO GROSSO DO SUL - INTERIOR", cepInicial: 79125000, cepFinal: 79999999, valor: 24.9, prazo: 19 },
{ regiao: "MINAS GERAIS - CAPITAL", cepInicial: 30000000, cepFinal: 31999999, valor: 16.9, prazo: 9 },
{ regiao: "MINAS GERAIS - INTERIOR", cepInicial: 32000000, cepFinal: 39999999, valor: 16.9, prazo: 9 },
{ regiao: "PARÁ - CAPITAL", cepInicial: 66000000, cepFinal: 66999999, valor: 24.9, prazo: 17 },
{ regiao: "PARÁ - INTERIOR", cepInicial: 67000000, cepFinal: 68899999, valor: 29.9, prazo: 17 },
{ regiao: "PARAÍBA - CAPITAL", cepInicial: 58000000, cepFinal: 58099999, valor: 24.9, prazo: 15 },
{ regiao: "PARAÍBA - INTERIOR", cepInicial: 58100000, cepFinal: 58999999, valor: 29.9, prazo: 15 },
{ regiao: "PARANÁ - CAPITAL", cepInicial: 80000000, cepFinal: 83800999, valor: 9.9, prazo: 5 },
{ regiao: "PARANÁ - INTERIOR", cepInicial: 83801000, cepFinal: 87999999, valor: 14.9, prazo: 9 },
{ regiao: "PERNAMBUCO - CAPITAL", cepInicial: 50000000, cepFinal: 54999999, valor: 29.9, prazo: 15 },
{ regiao: "PERNAMBUCO - INTERIOR", cepInicial: 55000000, cepFinal: 56999999, valor: 29.9, prazo: 15 },
{ regiao: "PIAUÍ - CAPITAL", cepInicial: 64000000, cepFinal: 64099999, valor: 29.9, prazo: 15 },
{ regiao: "PIAUÍ - INTERIOR", cepInicial: 64100000, cepFinal: 64999999, valor: 29.9, prazo: 15 },
{ regiao: "RIO DE JANEIRO - CAPITAL", cepInicial: 20000000, cepFinal: 26600999, valor: 12.9, prazo: 8 },
{ regiao: "RIO DE JANEIRO - INTERIOR", cepInicial: 26601000, cepFinal: 28999999, valor: 19.9, prazo: 10 },
{ regiao: "RIO GRANDE DO NORTE - CAPITAL", cepInicial: 59000000, cepFinal: 59099999, valor: 29.9, prazo: 15 },
{ regiao: "RIO GRANDE DO NORTE - INTERIOR", cepInicial: 59100000, cepFinal: 59999999, valor: 29.9, prazo: 15 },
{ regiao: "RIO GRANDE DO SUL - CAPITAL", cepInicial: 90000000, cepFinal: 94900999, valor: 9, prazo: 6 },
{ regiao: "RIO GRANDE DO SUL - INTERIOR", cepInicial: 94901000, cepFinal: 99999999, valor: 13.9, prazo: 8 },
{ regiao: "RONDONIA - CAPITAL", cepInicial: 76800000, cepFinal: 76833999, valor: 24.9, prazo: 15 },
{ regiao: "RONDONIA - INTERIOR", cepInicial: 76834000, cepFinal: 76999999, valor: 29.9, prazo: 15 },
{ regiao: "RORAIMA - CAPITAL", cepInicial: 69300000, cepFinal: 69339999, valor: 24.9, prazo: 15 },
{ regiao: "RORAIMA - INTERIOR", cepInicial: 69340000, cepFinal: 69389999, valor: 29.9, prazo: 15 },
{ regiao: "SANTA CATARINA - CAPITAL", cepInicial: 88000000, cepFinal: 88469999, valor: 7.9, prazo: 5 },
{ regiao: "SANTA CATARINA - INTERIOR", cepInicial: 88470000, cepFinal: 89999999, valor: 12.9, prazo: 6 },
{ regiao: "SAO PAULO - CAPITAL", cepInicial: 1000000, cepFinal: 9999999, valor: 9.99, prazo: 6 },
{ regiao: "SAO PAULO - INTERIOR", cepInicial: 11000000, cepFinal: 19999999, valor: 14.9, prazo: 8 },
{ regiao: "SERGIPE - CAPITAL", cepInicial: 49000000, cepFinal: 49099999, valor: 19.9, prazo: 15 },
{ regiao: "SERGIPE - INTERIOR", cepInicial: 49100000, cepFinal: 49999999, valor: 29.9, prazo: 15 },
{ regiao: "TOCANTINS - CAPITAL", cepInicial: 77000000, cepFinal: 77270999, valor: 19.9, prazo: 15 },
{ regiao: "TOCANTINS - INTERIOR", cepInicial: 77300000, cepFinal: 77995999, valor: 29.9, prazo: 15 }
];

function limparCEP(cep) {
  return parseInt(cep.replace(/\D/g, ''));
}

function calcularFrete() {
  const input = document.getElementById('cepInput').value;
  const cep = limparCEP(input);
  const resultado = document.getElementById('resultadoFrete');

  if (isNaN(cep) || input.length < 8) {
    resultado.innerHTML = "❌ Por favor, digite um CEP válido com 8 números.";
    return;
  }

  const faixa = faixasDeFrete.find(f =>
    cep >= f.cepInicial && cep <= f.cepFinal
  );

  if (faixa) {
    let mensagem = `
      📍 Região: ${faixa.regiao}<br>
      🚚 Frete: R$ ${faixa.valor.toFixed(2)}<br>
      ⏱️ Prazo: até ${faixa.prazo} dias úteis<br>
      
    `;

    resultado.innerHTML = mensagem;

  } else {
    resultado.innerHTML = "⚠️ Não encontramos uma faixa de frete para esse CEP.";
  }
}


